import { gaPush } from '@/configuration/setup/googleAnalytics';
import type { SourceDeviceValue } from '@/features/engineoil/utils/constants';

const AnalyticsEvents = {
    openSensorSignalMPreconditionsDialog: (sourceDevice: SourceDeviceValue) => {
        gaPush({
            event: 'open_sensorsignal_m_preconditionsdialog',
            parameters: {
                element_name: 'EngineOilPreConditionsAndFeedback',
                component_name: 'Button',
                trigger: 'click',
                flow_name: 'engine_oil',
                element_state: `source_device:${sourceDevice}`,
            },
            userProps: {},
        });
    },
    openSensorSignalSPreconditionsDialog: (sourceDevice: SourceDeviceValue) => {
        gaPush({
            event: 'open_sensorsignal_s_preconditionsdialog',
            parameters: {
                element_name: 'EngineOilPreConditionsAndFeedback',
                component_name: 'Button',
                trigger: 'click',
                flow_name: 'engine_oil',
                element_state: `source_device:${sourceDevice}`,
            },
            userProps: {},
        });
    },
    openDidMPreconditionsDialog: (sourceDevice: SourceDeviceValue) => {
        gaPush({
            event: 'open_did_m_preconditionsdialog',
            parameters: {
                element_name: 'EngineOilPreConditionsAndFeedback',
                component_name: 'Button',
                trigger: 'click',
                flow_name: 'engine_oil',
                element_state: `source_device:${sourceDevice}`,
            },
            userProps: {},
        });
    },
    openDidSPreconditionsDialog: (sourceDevice: SourceDeviceValue) => {
        gaPush({
            event: 'open_did_s_preconditionsdialog',
            parameters: {
                element_name: 'EngineOilPreConditionsAndFeedback',
                component_name: 'Button',
                trigger: 'click',
                flow_name: 'engine_oil',
                element_state: `source_device:${sourceDevice}`,
            },
            userProps: {},
        });
    },
    openSensorSignalPreconditionsDialog: (sourceDevice: SourceDeviceValue) => {
        gaPush({
            event: 'open_sensorsignal_preconditionsdialog',
            parameters: {
                element_name: 'FillingLevelsElement',
                component_name: 'Button',
                trigger: 'click',
                flow_name: 'engine_oil',
                element_state: `source_device:${sourceDevice}`,
            },
            userProps: {},
        });
    },
    openDidPreconditionsDialog: (sourceDevice: SourceDeviceValue) => {
        gaPush({
            event: 'open_did_preconditionsdialog',
            parameters: {
                element_name: 'FillingLevelsElement',
                component_name: 'Button',
                trigger: 'click',
                flow_name: 'engine_oil',
                element_state: `source_device:${sourceDevice}`,
            },
            userProps: {},
        });
    },
    hoverSensorSignalMSidebarCriticLow: (sourceDevice: SourceDeviceValue) => {
        gaPush({
            event: 'hover_sensorsignal_m_sidebar_criticlow',
            parameters: {
                element_name: 'EngineOilDtcTooltip',
                component_name: 'Icon',
                trigger: 'visibility', // it should be 'hover' but that is not a trigger supported by RIO
                flow_name: 'engine_oil',
                element_state: `source_device:${sourceDevice}`,
            },
            userProps: {},
        });
    },
    hoverSensorSignalSSidebarCriticLow: (sourceDevice: SourceDeviceValue) => {
        gaPush({
            event: 'hover_sensorsignal_s_sidebar_criticlow',
            parameters: {
                element_name: 'EngineOilDtcTooltip',
                component_name: 'Icon',
                trigger: 'visibility', // it should be 'hover' but that is not a trigger supported by RIO
                flow_name: 'engine_oil',
                element_state: `source_device:${sourceDevice}`,
            },
            userProps: {},
        });
    },
    hoverDidSidebarOlder24h: (sourceDevice: SourceDeviceValue) => {
        gaPush({
            event: 'hover_did_sidebar_older24h',
            parameters: {
                element_name: 'InformationSignWithOutdatedTooltip',
                component_name: 'Icon',
                trigger: 'visibility', // it should be 'hover' but that is not a trigger supported by RIO
                flow_name: 'engine_oil',
                element_state: `source_device:${sourceDevice}`,
            },
            userProps: {},
        });
    },
    hoverSensorSignalSidebarOlder24h: (sourceDevice: SourceDeviceValue) => {
        gaPush({
            event: 'hover_sensorsignal_sidebar_older24h',
            parameters: {
                element_name: 'InformationSignWithOutdatedTooltip',
                component_name: 'Icon',
                trigger: 'visibility', // it should be 'hover' but that is not a trigger supported by RIO
                flow_name: 'engine_oil',
                element_state: `source_device:${sourceDevice}`,
            },
            userProps: {},
        });
    },
    hoverDidCardOlder24h: (sourceDevice: SourceDeviceValue) => {
        gaPush({
            event: 'hover_did_card_older24h',
            parameters: {
                element_name: 'ExclamationSignWithOutdatedTooltip',
                component_name: 'Icon',
                trigger: 'visibility', // it should be 'hover' but that is not a trigger supported by RIO
                flow_name: 'engine_oil',
                element_state: `source_device:${sourceDevice}`,
            },
            userProps: {},
        });
    },
    hoverSensorSignalCardOlder24h: (sourceDevice: SourceDeviceValue) => {
        gaPush({
            event: 'hover_sensorsignal_card_older24h',
            parameters: {
                element_name: 'ExclamationSignWithOutdatedTooltip',
                component_name: 'Icon',
                trigger: 'visibility', // it should be 'hover' but that is not a trigger supported by RIO
                flow_name: 'engine_oil',
                element_state: `source_device:${sourceDevice}`,
            },
            userProps: {},
        });
    },
    clickSpnBtn: (sourceDevice: SourceDeviceValue) => {
        gaPush({
            event: 'click_spn_btn',
            parameters: {
                element_name: 'EngineOilDtcElement',
                component_name: 'Button',
                trigger: 'click',
                flow_name: 'engine_oil',
                element_state: `source_device:${sourceDevice}`,
            },
            userProps: {},
        });
    },
    openDidFeedbackEngineOil: (sourceDevice: SourceDeviceValue) => {
        gaPush({
            event: 'open_did_feedback_engineoil',
            parameters: {
                element_name: 'EngineOilPreConditionsAndFeedback',
                component_name: 'Button',
                trigger: 'click',
                flow_name: 'engine_oil',
                element_state: `source_device:${sourceDevice}`,
            },
            userProps: {},
        });
    },
};

export default AnalyticsEvents;
